import { AfterViewInit, Component, Input, ViewChild, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { TooltipDirective } from '../tooltip.directive';

@Component({
  selector: 'valg-tooltip-button',
  templateUrl: './tooltip-button.component.html',
  host: {'class': 'd-flex'}
})
export class TooltipButtonComponent implements OnInit, AfterViewInit{
  @Input() tooltip!: string;
  @Input() positionY: 'below' | 'above' = 'below';
  @Input() positionX: 'start' | 'end' | 'center' = 'end';
  @Input() altIcon: SvgIcon | null = null;
  @Input() altIconOutlined: SvgIcon | null = null;
  
  @ViewChild(TooltipDirective) tooltipDir!: TooltipDirective;
  public SvgIcon: SvgIcon = SvgIcon.Questionmark;
  public SvgIconOutlined: SvgIcon = SvgIcon.QuestionmarkOutlined;
  isOpen = false;

  constructor(
    protected translate: TranslateService
    ){
  }
  ngOnInit(): void {
    if(this.altIcon != null){
      this.SvgIcon = this.altIcon;
    }
    if(this.altIconOutlined != null){
      this.SvgIconOutlined = this.altIconOutlined;
    }
  }

  ngAfterViewInit(): void{   
    if(this.tooltipDir){
      this.tooltipDir.opened.subscribe({
        next: () => {
          this.SvgIconOutlined = this.altIconOutlined ?? SvgIcon.QuestionmarkOutlined;
          this.isOpen = true;
        }
      });
      this.tooltipDir.closed.subscribe({
        next: () => {
          this.SvgIcon = this.altIcon ?? SvgIcon.Questionmark;
          this.isOpen = false;
        }
      });
    }
  }
}
